angular
    .module('clickbooth-common')
    .service('htmlFormattedModal', ['$rootScope', '$modal', function ($rootScope, $modal) {
        let scope = $rootScope.$new(true);
        let modal = $modal({
            scope: scope,
            templateUrl: template('modals/html-formatted-modal'),
            backdrop: 'static',
            show: false
        });

        return {
            show: function(options) {
                scope.modalOptions = options;
                modal.$promise.then(modal.show);
            },
            hide: function(){
                modal.hide();
            }
        };
    }]);
